export const timeIsOver = (SLA) => new Date().valueOf() - 86400000 > new Date(SLA).valueOf();
